module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("添加专题")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "topicForm",
    attrs: {
      "model": _vm.topicForm,
      "rules": _vm.addTopicRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专题标题",
      "label-width": "150px",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.topicForm.title),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "title", $$v)
      },
      expression: "topicForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专题描述",
      "label-width": "150px",
      "prop": "caption"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.topicForm.caption),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "caption", $$v)
      },
      expression: "topicForm.caption"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传banner图",
      "label-width": "150px",
      "prop": "banner"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "on-error": _vm.handleError,
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.topicForm.banner) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.topicForm.banner
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跳转类型选择",
      "label-width": "150px",
      "prop": "topicType"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.topicForm.topicType),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "topicType", $$v)
      },
      expression: "topicForm.topicType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("商品分类")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("商品标签")])], 1)], 1), _vm._v(" "), (_vm.topicForm.topicType) ? _c('el-form-item', {
    attrs: {
      "label": "已选择",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.choosedNow),
      callback: function($$v) {
        _vm.choosedNow = $$v
      },
      expression: "choosedNow"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专题下的商品选择",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "商品"
    },
    on: {
      "change": _vm.productChoose
    },
    model: {
      value: (_vm.topicForm.shop),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "shop", $$v)
      },
      expression: "topicForm.shop"
    }
  }, _vm._l((_vm.productArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), (_vm.topicForm.product) ? _c('el-form-item', {
    attrs: {
      "label": "当前租金(元)",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.topicForm.product.rental),
      callback: function($$v) {
        _vm.$set(_vm.topicForm.product, "rental", $$v)
      },
      expression: "topicForm.product.rental"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.topicForm.product) ? _c('el-form-item', {
    attrs: {
      "label": "商品原价(元)",
      "label-width": "150px",
      "prop": "oldRental"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.topicForm.product.oldRental),
      callback: function($$v) {
        _vm.$set(_vm.topicForm.product, "oldRental", $$v)
      },
      expression: "topicForm.product.oldRental"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专题二维码尺寸",
      "label-width": "150px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "on-error": _vm.handleError,
      "show-file-list": false,
      "on-success": _vm.handlePicArrSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.topicUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.topicUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("添加该商品")])], 1), _vm._v(" "), (_vm.topicForm.productDetails.length) ? _c('el-form-item', {
    attrs: {
      "label": "已选择商品",
      "label-width": "150px"
    }
  }, [_c('el-row', _vm._l((_vm.topicForm.productDetails), function(o, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 8,
        "offset": index > 0 ? 2 : 0
      }
    }, [_c('el-card', {
      attrs: {
        "body-style": {
          padding: '0px'
        }
      }
    }, [(o.qrcode) ? _c('img', {
      staticClass: "image",
      attrs: {
        "src": o.qrcode
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "14px"
      }
    }, [_c('span', [_vm._v(_vm._s(o.name))]), _vm._v(" "), _c('div', {
      staticClass: "bottom clearfix"
    }, [_c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.remove(index)
        }
      }
    }, [_vm._v("删除")])], 1)])])], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择标签"
    },
    model: {
      value: (_vm.chooseTopic),
      callback: function($$v) {
        _vm.chooseTopic = $$v
      },
      expression: "chooseTopic"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_topic
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择标签",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "标签"
    },
    model: {
      value: (_vm.cur_topic.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_topic, "now", $$v)
      },
      expression: "cur_topic.now"
    }
  }, _vm._l((_vm.topicArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.tagId,
      attrs: {
        "label": item.name,
        "value": item.tagId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseTopic = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.topicChoose
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择分类"
    },
    model: {
      value: (_vm.chooseCatogry),
      callback: function($$v) {
        _vm.chooseCatogry = $$v
      },
      expression: "chooseCatogry"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_categroy
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择分类",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    model: {
      value: (_vm.cur_categroy.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_categroy, "now", $$v)
      },
      expression: "cur_categroy.now"
    }
  }, _vm._l((_vm.categoryArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.categoryId,
      attrs: {
        "label": item.name,
        "value": item.categoryId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseCatogry = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.catogryChoose
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e998319"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/AddTopic.vue
// module id = 718
// module chunks = 1